var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('SSHeader'),_vm._v(" "),_c('b-container',[_c('router-view')],1),_vm._v(" "),_c('SSFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }